import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {ConfigService} from '../services/utils/config.service';

@Injectable()
export class HomeRedirectGuard implements CanActivate {
    constructor(private configService: ConfigService, private router: Router) {}

    async canActivate(): Promise<boolean> {
        if (!this.configService.enabledAppList || this.configService.enabledAppList.length === 0) {
            console.log('No disposem d\'aplicacions configurades, forcem recàrrega de configuració');
            await this.configService.loadConfig();
            console.log(`S'han trobat ${this.configService.enabledAppList} aplicacions`);
        }
        const enabledApps = this.configService.enabledAppList;

        if (enabledApps.includes('public')) {
            this.router.navigateByUrl('/public');
        } else {
            this.router.navigateByUrl('/privat');
        }

        return false;
    }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/guard/HomeRedirectGuard.ts